import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';
import { CustomValidators } from 'src/validators';
import * as accents from 'remove-accents';
import * as moment from 'moment';
import { DomSanitizer } from '@angular/platform-browser';
import { PlatformLocation } from '@angular/common';
import * as SINONIMO from 'src/assets/sinonimo.json';

@Component({
  selector: 'app-step-three',
  templateUrl: './step-three.component.html',
  styleUrls: ['./step-three.component.scss']
})
export class StepThreeComponent implements OnInit {

  form: UntypedFormGroup;
  formVacancy: UntypedFormGroup;
  @Output() formObserver: Subject<UntypedFormGroup>;
  @Output() submit: EventEmitter<boolean>;
  @Input() initData: EventEmitter<any>;
  vacancies: Array<any>;
  submiting: boolean = false;
  filteredVacancies$: Observable<any>;
  filteredBranch$: Observable<any>;
  filteredRoleLevel$: Observable<any>;
  filteredSpecializationName$: Observable<any>;
  allVacancies: Array<any> = [];
  allBranch: Array<any> = [];
  allRoleLevel: Array<any> = [];
  allOffices: Array<any> = [];
  allSpecializationName: Array<any> = [];
  showForm: boolean = true;
  mauticFormSrc: any = null;
  sinonimos: Array<any> = (SINONIMO as any).default;
  allSinonimo
  filteredSinonimo

  constructor(
    fb: UntypedFormBuilder,
    private http: HttpService,
    private errorReport: ErrorReportService,
    private sanitazer: DomSanitizer,
    private pLocation: PlatformLocation,
  ) {

    this.allSinonimo = this.sinonimos;
    //this.filteredSinonimo = this.allSinonimo;
    
    this.form = fb.group({
      firstJob: [false, Validators.required],
      isPcd: [false, Validators.required],
      pcdDescription: [null]
    })
    this.formVacancy = fb.group({
      company: [null, Validators.required],
      vacancy: [null],
      branch: [null],
      roleLevel: [null],
      specializationName: [null],
      description: [null, Validators.required],
      salary: [null],
      currentJob: [false],
      admissionDate: [ null, [ CustomValidators.beforeDate('departureDate', 'MMyyyy'), CustomValidators.date('MMyyyy') ] ],
      departureDate: [ null, [ CustomValidators.maxDate(moment(), 'MMyyyy'), CustomValidators.date('MMyyyy') ] ],
      office: [null],
      sinonimo: [null, Validators.required],
      workregime: [null, Validators.required],
      modalityjob:[null, Validators.required],
    })
    this.vacancies = Array<any>();
    this.submit = new EventEmitter<any>();
    this.formObserver = new Subject<UntypedFormGroup>();

  }

  ngOnInit(): void {

    this.formObserver.next(this.form);
    this.formVacancy.get('currentJob')
      .valueChanges
      .subscribe(_ => this.formVacancy.patchValue({ departureDate: null }))

    // this.filteredVacancies$ = this.formVacancy.get('vacancy')
    //   .valueChanges
    //   .pipe(
    //     map(vacancy => this._filterVacancies(vacancy))
    //   );

    // this.filteredBranch$ = this.formVacancy.get('branch')
    //   .valueChanges
    //   .pipe(
    //     map(branch => this._filterBranch(branch))
    //   );

    // this.filteredRoleLevel$ = this.formVacancy.get('roleLevel')
    //   .valueChanges
    //   .pipe(
    //     map(role_level => this._filterRoleLevel(role_level))
    //   );

    // this.filteredSpecializationName$ = this.formVacancy.get('specializationName')
    //   .valueChanges
    //   .pipe(
    //     map(specializationName => this._filterSpecializationName(specializationName))
    //   );

    // this.http.list('vacancy')
    //   .subscribe((vacancies: any) => this.allVacancies = vacancies);

    // this.http.list('vacancy:specialization_name')
    //   .subscribe((specializationName: any) => this.allSpecializationName = specializationName);

    // this.http.list('vacancy:branch')
    //   .subscribe((branch: any) => this.allBranch = branch);

    // this.http.list('vacancy:role_level')
    //   .subscribe((roleLevel: any) => this.allRoleLevel = roleLevel);

    const subject = new Subject<any>();
    subject.subscribe(
      result => {
        const { trigger, scope } = result;
        if (scope === 'professional_experience') {
          this.submiting = trigger === 'pre';
        }
      }
    )
    this.http.setLoadingIndicator(subject);

  }

  // ngAfterViewInit() {

  //   if (this.initData) {
  //     this.initData.subscribe((data) => {

  //       this.form.patchValue(
  //         {
  //           firstJob: data['user'].first_job,
  //           isPcd: data['user'].is_pcd == 'true' ? true : false,
  //           pcdDescription: data['user'].pcd_description
  //         },
  //         { emitEvent: false }
  //       );
  //     })
  //   }

  // }

  public addVacancy() {

    const isValid = !this.formVacancy.invalid;

    if (isValid) {

      const data = this.formVacancy.getRawValue();

      if (data.admissionDate)
      data.admissionDate = moment(data.admissionDate, 'MM/YYYY').format('YYYY-MM-DD');

      if (data.departureDate)
        data.departureDate = moment(data.departureDate, 'MM/YYYY').format('YYYY-MM-DD');

      this.vacancies.push({ ...data });
      // this.formVacancy.reset({ currentJob: false });
      this.formVacancy.markAsPristine();
      // this.showForm = false;

    }

  }

  public resetForm() {

    this.formVacancy.reset({ currentJob: false });
    this.showForm = false;

  }

  public removeItem(i: number) {

    if (!confirm('Deseja remover esse item'))
      return;

    this.vacancies.splice(i, 1);

  }

  public onSubmit() {

    if (this.formVacancy.dirty)
      this.addVacancy();

    // if (this.vacancies.length || !this.form.invalid) {

      const data = {
        email: localStorage.getItem('email'),
        firstJob: this.form.get('firstJob').value,
        isPcd: this.form.get('isPcd').value,
        pcdDescription: this.form.get('pcdDescription').value,
        vacancies: JSON.stringify(this.vacancies)
      }
    
      // console.log('Profissional', data);
    
      const params = new URLSearchParams();
      params.append('email', data.email);
      const bHref = this.pLocation.getBaseHrefFromDOM();
      this.mauticFormSrc = this.sanitazer
        .bypassSecurityTrustResourceUrl(`${bHref}mautic-form/step-three?${params.toString()}`);

      this.http.save('professional_experience', data)
        .subscribe(
          (result: any) => {
    
            if (result.type === 'OK')
              this.submit.emit();
          },
          err => this.errorReport.showMessage(err)
        );

    // }
    
    this.submit.emit();

  }

  onBlurInput(name: string): void {

    setTimeout(() => {

      const control = this.formVacancy.get(name);
      let invalid = false;
      switch (name) {
        // case 'vacancy': invalid = this.allVacancies.findIndex(vacancy => vacancy.professional_name === control.value) === -1; break;
        // case 'specializationName': invalid = this.allSpecializationName.findIndex(specializationName => specializationName.specialization_name === control.value) === -1; break;
        // case 'roleLevel': invalid = this.allRoleLevel.findIndex(roleLevel => roleLevel.role_level === control.value) === -1; break;
        // case 'branch': invalid = this.allBranch.findIndex(branch => branch.branch === control.value) === -1; break;
        case 'sinonimo': invalid = this.allSinonimo.findIndex(_sinonimo => _sinonimo.Name === control.value) === -1; break;
      }

      if (invalid) {
        control.setValue(null);
        control.setErrors({
          invalid: true
        })
      }

    }, 500)

  }

  // private _filterVacancies(vacancy) {
  //   if (vacancy == null) return;
  //   vacancy = accents.remove(vacancy).toLowerCase().trim();
  //   return this.allVacancies.filter(_vacancy => accents.remove(_vacancy.professional_name).toLowerCase().includes(vacancy));
  // }

  // private _filterBranch(branch) {
  //   if (branch == null) return;
  //   branch = accents.remove(branch).toLowerCase().trim();
  //   return this.allBranch.filter(_branch => accents.remove(_branch.branch).toLowerCase().includes(branch));
  // }

  // private _filterSpecializationName(specializationName) {
  //   if (specializationName === null) return;
  //   specializationName = accents.remove(specializationName).toLowerCase().trim();
  //   return this.allSpecializationName.filter(_specialization_name => accents.remove(_specialization_name.specialization_name).toLowerCase().indexOf(specializationName) > -1);
  // }

  // private _filterRoleLevel(roleLevel) {

  //   if (roleLevel === null) return;
  //   roleLevel = accents.remove(roleLevel).toLowerCase().trim();
  //   return this.allRoleLevel.filter(_role_level => accents.remove(_role_level.role_level).toLowerCase().indexOf(roleLevel) > -1);

  // }

  public _filterSinonimo(Sinonimo) {
    if(Sinonimo === null) return;
     //Filtra apenas quando tiver mais que 3 caracteres
    if (Sinonimo.length >= 3) {
      Sinonimo = accents.remove(Sinonimo).toLowerCase().trim();
      this.filteredSinonimo = this.allSinonimo.filter(_sinonimo => accents.remove(_sinonimo.Name).toLowerCase().indexOf(Sinonimo) > -1);
    }else{
      return;
    }
  }

  onFocusInput(inputName: string) {

    const inputControl = this.formVacancy.get(inputName);
    const pristine = inputControl.pristine;

    if (pristine)
      inputControl.setValue(' ');

  }

  onToggleChange() {
    const firstJobValue = this.form.get('firstJob').value;
  
    if (firstJobValue) {
      this.formVacancy.get('company').clearValidators();
      this.formVacancy.get('company').updateValueAndValidity();
      this.formVacancy.get('description').clearValidators();
      this.formVacancy.get('description').updateValueAndValidity();
      this.formVacancy.get('sinonimo').clearValidators();
      this.formVacancy.get('sinonimo').updateValueAndValidity();
      this.formVacancy.get('admissionDate').clearValidators();
      this.formVacancy.get('admissionDate').updateValueAndValidity();
      this.formVacancy.get('departureDate').clearValidators();
      this.formVacancy.get('departureDate').updateValueAndValidity();
    } else {
      this.formVacancy.get('company').setValidators([Validators.required]);
      this.formVacancy.get('company').updateValueAndValidity();
      this.formVacancy.get('description').setValidators([Validators.required]);
      this.formVacancy.get('description').updateValueAndValidity();
      this.formVacancy.get('sinonimo').setValidators([Validators.required]);
      this.formVacancy.get('sinonimo').updateValueAndValidity();
      this.formVacancy.get('admissionDate').setValidators([
        CustomValidators.beforeDate('departureDate', 'MMyyyy'),
        CustomValidators.date('MMyyyy')
      ]);
      this.formVacancy.get('admissionDate').updateValueAndValidity();
      this.formVacancy.get('departureDate').setValidators([
        CustomValidators.maxDate(moment(), 'MMyyyy'),
        CustomValidators.date('MMyyyy')
      ]);
      this.formVacancy.get('departureDate').updateValueAndValidity();
    }
  
    this.showForm = !firstJobValue;

  }

}
